import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
// components Icons

import CloseIcon from "../Components/Icons/CloseIcon";
import { clearProductMediaUploads } from "../../uploads/productMediaUploadManager";
// store
import { getOrganisation } from "../../Store/organisation/actions";
import { refreshStudioEntitlements } from "../../helpers/studioEntitlementsApi";
import SideMiniExpand from "./SideMiniExpand";
import SideMiniCollaspe from "./SideMiniCollaspe";
import { clearAfterExpiry, isKarkhanaSupervisor } from "../../helpers/karkhanaEnabled";
import notifications from "../Components/Notifications/Notification";
import { readLang, translate } from "../../pages/karkhana/i18n/kt";
import { hasRememberedPhone, recoverExpiredLogin } from "../../pages/karkhana/supervisor/supervisorSession";

const VerticalMenuBar = (props: any) => {
  let auth: any = localStorage.getItem("authUser");
  let authUser: any = JSON.parse(auth) || "";
  let res: any = localStorage.getItem("response");
  let response: any = JSON.parse(res) || "";
  const location = useLocation();
  const history = useHistory();

  const [name, setName]: any = useState("");
  const [authTick, setAuthTick] = useState(0);

  useEffect(() => {
    refreshStudioEntitlements()
      .then((ok) => {
        if (ok) {
          setAuthTick((n) => n + 1);
        }
      })
      .catch(() => undefined);
  }, []);

  useEffect(() => {
    if (
      response.message === "MODULE_REQUIRED" ||
      response.message === "FEATURE_DISABLED"
    ) {
      localStorage.removeItem("response");
      return;
    }
    const expired = response.status === 401 || response.message === "UnAuthorized!" || response.message === "Unauthorized!";
    // Only a supervisor's expired login is renewed from their phone (a 403 would just come back).
    if (expired && isKarkhanaSupervisor(authUser?.users?.role) && hasRememberedPhone()) {
      localStorage.removeItem("response");
      recoverExpiredLogin(true).then((result) => {
        if (result === "signed-out") history.push("/karkhana/login");
        if (result === "renewed") {
          const lang = readLang();
          notifications({
            title: translate(lang, "Signed in again"),
            message: translate(lang, "Refresh the page to see your work."),
            type: "info",
          });
        }
      });
      return;
    }
    if (expired || response.status === 403 || response.statusText === "Forbidden") {
      const supervisor = isKarkhanaSupervisor(authUser?.users?.role);
      // Everything goes except Daily work still unsaved on this phone (written first, kept per user).
      clearAfterExpiry();
      localStorage.removeItem("response");
      void clearProductMediaUploads();
      history.push(supervisor ? "/karkhana/login" : "/login");
      localStorage.removeItem("response");
    }
  });

  const handleClick = (type: any) => {
    setName(type?.name);
  };
  return (
    <>
      {props.show && (
        <div id={"my-sidebar-mobile"} className={`mainExpandedStyle`}>
          <button
            type="button"
            className="closeIconStyle studio-drawer-close"
            aria-label="Close menu"
            onClick={props.closeSideBar}
          >
            <CloseIcon closeSideBar={props.closeSideBar} stroke="currentColor" />
          </button>
          <SideMiniExpand
            key={authTick}
            {...props}
            authUser={authUser}
            handleClick={handleClick}
            location={location}
            closeSideBar={props.closeSideBar}
          />
        </div>
      )}
      {props.mini && (
        <>
          <div
            id={props.show ? "my-sidebar-mobile" : "mySidebar"}
            className={`mainExpandedStyle`}
          >
            {props.show ? (
              <button
                type="button"
                className="closeIconStyle studio-drawer-close"
                aria-label="Close menu"
                onClick={props.closeSideBar}
              >
                <CloseIcon closeSideBar={props.closeSideBar} stroke="currentColor" />
              </button>
            ) : (
              ""
            )}
            <SideMiniExpand
              {...props}
              authUser={authUser}
              handleClick={handleClick}
              location={location}
              closeSideBar={props.closeSideBar}
            />
          </div>
        </>
      )}
      {props?.mini === false && (
        <>
          <div id="mySidebar" className={`mainExpandedStyles`}>
            <SideMiniCollaspe
              {...props}
              authUser={authUser}
              handleClick={handleClick}
              location={location}
            />
          </div>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    ...state,
  };
};
export default connect(mapStateToProps, {
  getOrganisation,
})(withRouter(VerticalMenuBar));
